import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';
// layouts
import advanced from './layouts/advanced.html';
// elements
import footer from './elements/footer.html';
import header from './elements/footer.html';
import post1Col from './elements/post1Col.html';
import post2Col from './elements/post2Col.html';
import post3Col from './elements/post3Col.html';
import richtext from './elements/richtext.html';
import title from './elements/title.html';

export function EmailComposeRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailCompose', {
		url: '/email/compose',
		controllerAs: 'vm',
		controller: EmailComposeCtrl,
		templateUrl: '/ng/hub/Email/Compose/EmailComposeCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Email/Compose/EmailComposeCtrl.css'),
			$title: () => 'Build an Email Brief',
		},
	});
}

export class EmailComposeCtrl {
	constructor(modal, $templateCache) {
		'ngInject';
		this.modal = modal;
		$templateCache.put('virtual/email/layouts/advanced.html', advanced);
		$templateCache.put('virtual/email/elements/footer.html', footer);
		$templateCache.put('virtual/email/elements/header.html', header);
		$templateCache.put('virtual/email/elements/post1Col.html', post1Col);
		$templateCache.put('virtual/email/elements/post2Col.html', post2Col);
		$templateCache.put('virtual/email/elements/post3Col.html', post3Col);
		$templateCache.put('virtual/email/elements/richtext.html', richtext);
		$templateCache.put('virtual/email/elements/title.html', title);
		this.name = 'EmailCompose';
		this.email = {
			layout: 'advanced',
			elements: [
				{ type: 'header', value: 'Test Header' },
				{ type: 'richtext', value: '<p>My little pony</p>' },
				{ type: 'footer', value: 'Test Footer' },
				{ type: 'post1Col', value: 'Test Post 1' },
				{ type: 'richtext', value: '<p>I am a brony</p>' },
				{ type: 'title', value: 'Test Title' },
			],
		};
	}

	removeElement(element) {
		const idx = _.findIndex(this.email.elements, element);
		this.email.elements.splice(idx, 1);
	}

	pickPost() {
		this.modal.state('hub.loggedin.PostPicker', {
			heading: 'Add posts to email',
			width: 800,
			padding: false,
			height: 'full',
			locals: {
				alreadyPicked: [3765], // TODO: get ids of all our posts
				sendToParent: this.addPickedPost.bind(this),
			},
		});
	}

	addPickedPost(post) {
		console.log('ready to add post', post);
	}

	editPost(post) {
		this.modal
			.state('hub.loggedin.PostEdit', {
				params: { id: post.id },
				heading: 'Edit Post',
				width: 675,
				height: 550 - 62,
				padding: false,
			})
			.then(() => {
				// reload post
			});
	}
}
